import React from "react";

const About = () => {
  return (
    <div>
      <h1>About Us</h1>
      <p>Learn about our journey and craftsmanship!</p>
    </div>
  );
};

export default About;